/**
 * 🎨 PALETTE DE COULEURS - UNIVERSAL COLD PLANNIT®
 * Version: v3.7.0
 * Date: 7 février 2026
 * 
 * Fichier corrigé avec TOUTES les couleurs utilisées dans l'application
 * 42 couleurs définies (vs 19 dans l'ancienne version)
 * 
 * Utilisation: import { colors } from '../../styles/colors';
 */

export const colors = {
  // =========================================
  // === BLEUS PRINCIPAUX ===
  // =========================================
  primary: 'rgba(0, 128, 255, 1)',                    // ✅ CORRIGÉ: était 'rgb(255, 255, 255)' (blanc) !
  primaryBlue: 'rgb(25, 118, 210)',                  // Bleu standard Material Design
  primaryDark: 'rgba(1, 5, 84, 1)',                // Bleu très foncé UCP (sidebar, bordures)
  secondaryBlue: 'rgb(66, 165, 245)',                // Bleu clair
  secondary: 'rgb(66, 165, 245)',                    // Alias pages publiques / accents
  primaryLight: 'rgba(25, 118, 210, 0.1)', // Bleu avec opacité pour ombres
  
  // =========================================
  // === GRADIENTS === ✅ AJOUTÉ
  // =========================================
  gradientBlue: 'linear-gradient(90deg, rgba(1, 5, 84, 1), rgba(0, 128, 255, 1))',           // Gradient bleu WelcomeSection
  gradientBlueGreen: 'linear-gradient(135deg, rgba(0, 128, 255, 1) 0%, rgba(0, 177, 0, 1) 100%)', // Gradient bleu-vert boutons
  
  // =========================================
  // === COULEURS DE BASE ===
  // =========================================
  white: 'rgb(255, 255, 255)',
  black: 'rgb(0, 0, 0)',
  background: 'rgb(245, 245, 245)',                   // Fond pages (gris très clair)
  backgroundLight: 'rgb(245, 245, 245)',              // Alias pour compatibilité
  cardBackground: 'rgb(255, 255, 255)',               // ✅ AJOUTÉ - Fond cartes blanches
  
  // =========================================
  // === TEXTE ===
  // =========================================
  text: 'rgb(44, 62, 80)',                         // ✅ AJOUTÉ - Texte principal (gris foncé)
  darkText: 'rgb(33, 33, 33)',                     // Texte très foncé (presque noir)
  textLight: 'rgb(117, 117, 117)',                    // Texte clair (gris moyen)
  textSecondary: 'rgb(127, 140, 141)',                // ✅ CORRIGÉ: était 'rgb(117, 117, 117)' - Texte secondaire
  textPrimary: 'rgb(255, 255, 255)',                  // Texte blanc (sur fond foncé)
  
  // =========================================
  // === BORDURES === ✅ AJOUTÉ
  // =========================================
  border: 'rgb(224, 224, 224)',                       // Bordure standard (gris clair)
  borderFocus: 'rgba(0, 128, 255, 1)',                // Bordure au focus (bleu UCP)
  
  // =========================================
  // === ÉTATS ===
  // =========================================
  success: 'rgba(0, 177, 0, 1)',                    // ✅ CORRIGÉ: était 'rgba(0, 163, 5, 1)' - Vert UCP
  error: 'rgb(231, 76, 60)',                        // ✅ CORRIGÉ: était 'rgba(255, 0, 0, 1)' - Rouge Material Design
  warning: 'rgb(243, 156, 18)',                      // ✅ CORRIGÉ: était 'rgba(255, 191, 0, 1)' - Orange Material Design
  
  // =========================================
  // === STATUTS INTERVENTIONS === ✅ AJOUTÉ ENTIÈREMENT
  // =========================================
  
  // Statut "Planifiée" (Bleu)
  statusPlanned: 'rgb(227, 242, 253)',                // Fond bleu clair
  statusPlannedBg: 'rgb(227, 242, 253)',              // Alias pour background
  statusPlannedText: 'rgb(25, 118, 210)',            // Texte bleu foncé
  
  // Statut "En Cours" (Orange)
  statusInProgress: 'rgb(255, 243, 224)',             // Fond orange clair
  statusInProgressBg: 'rgb(255, 243, 224)',           // Alias pour background
  statusInProgressText: 'rgb(245, 124, 0)',         // Texte orange foncé
  
  // Statut "Terminée" / "Complété" / "Soumis" (Vert)
  statusCompleted: 'rgb(232, 245, 233)',              // Fond vert clair
  statusCompletedBg: 'rgb(232, 245, 233)',            // Alias pour background
  statusCompletedText: 'rgb(56, 142, 60)',          // Texte vert foncé
  
  // Statuts spéciaux
  statusUrgent: 'rgb(231, 76, 60)',                 // Rouge pour "Urgent" ou "En retard"
  statusWarning: 'rgb(243, 156, 18)',                // Orange pour "Attention" ou "Warning"
  
  // =========================================
  // === UI SPÉCIFIQUE ===
  // =========================================
  sidebarBg: 'rgba(1, 1, 77, 1)',          // Fond sidebar (bleu très foncé UCP)
  
  // Boutons
  buttonPrimary: 'rgba(0, 128, 255, 1)',              // ✅ CORRIGÉ: était 'rgb(52, 152, 219)' - Bouton principal bleu UCP
  buttonPrimaryDark: 'rgba(1, 5, 84, 1)',          // ✅ CORRIGÉ: était 'rgb(41, 128, 185)' - Hover bouton principal
  buttonSuccess: 'rgba(0, 177, 0, 1)',              // ✅ CORRIGÉ: était 'rgb(39, 174, 96)' - Bouton succès vert UCP
  buttonDanger: 'rgb(231, 76, 60)',                 // Bouton danger rouge
  
  // =========================================
  // === TRANSPARENCES ===
  // =========================================
  overlayLight: 'rgba(255, 255, 255, 0.8)', // Overlay blanc semi-transparent
  overlayDark: 'rgba(0, 0, 0, 0.1)',         // Overlay noir léger
  
  // =========================================
  // === STATCARDS COULEURS STANDARD (12MARS2026) ===
  // =========================================
  // Ordre visuel bleu→vert→orange→violet pour cohérence multirôle
  statCard1: 'rgba(1, 132, 255, 1)',    // Bleu (Total, Planifiées, etc.)
  statCard2: 'rgba(0, 177, 0, 1)',      // Vert (En Cours, Actifs, etc.)
  statCard3: 'rgba(255, 94, 0, 1)',     // Orange (Planifiées alt, Téléchargés, etc.)
  statCard4: 'rgba(161, 0, 190, 1)',    // Violet (Terminées, Productivité, etc.)

  // Notes planning — teal distinct des barres intervention (couleurs assignés)
  planningNote: 'rgb(13, 148, 136)',       // Formulaires / choix création (entité note)
  planningNoteDark: 'rgb(15, 118, 110)'    // Accent formulaire note
};

// Export par défaut pour compatibilité
export default colors;

